export default class PollCountModel{
    count:number|undefined;
    postId:string|undefined;
    sourceId:string|undefined;
    sourceType:string|undefined;
    userIds:any[]=[];
}